import {registerBlockType} from '@wordpress/blocks';
import {attributes} from './attributes';
import blockJson from './block.json';
import {Edit, Save} from './edit';
import {Block} from './frontend';
import {registerCheckoutBlock} from '@woocommerce/blocks-checkout'

const metadata = {
	...blockJson,
	attributes: {
		...blockJson.attributes,
		...attributes,
	},
};

registerBlockType(blockJson.name, {
	apiVersion: metadata.apiVersion,
	title: metadata.title,
	icon: {
		src:
			(
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" width="24" height="24" aria-hidden="true" focusable="false" style={{fill: 'none'}}>
					<path d="M8 11.75H16M5 16.25H19C19.6904 16.25 20.25 15.6904 20.25 15V8.5C20.25 7.80964 19.6904 7.25 19 7.25H5C4.30964 7.25 3.75 7.80964 3.75 8.5V15C3.75 15.6904 4.30964 16.25 5 16.25Z" vector-effect="non-scaling-stroke"></path>
				</svg>
			),
		foreground: '#874FB9'
	},
	attributes: metadata.attributes,
	save: Save,
	edit: Edit,
})

registerCheckoutBlock({
	metadata,
	component: Block
});
